import { render, staticRenderFns } from "./ChooseDisplay.vue?vue&type=template&id=829e887e&scoped=true&"
import script from "./ChooseDisplay.vue?vue&type=script&lang=js&"
export * from "./ChooseDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ChooseDisplay.vue?vue&type=style&index=0&id=829e887e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829e887e",
  null
  
)

component.options.__file = "ChooseDisplay.vue"
export default component.exports